import React, { useEffect, useState } from "react";
import { API_BASE } from "../../Utils/constant";

const TermsAndConditions = () => {
  const [termsData, setTermsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTermsAndConditions = async () => {
      try {
        const response = await fetch(`${API_BASE}/terms-and-conditions`);
        if (!response.ok) {
          throw new Error("Failed to fetch terms and conditions");
        }
        const data = await response.json();


        setTermsData([data.data]);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTermsAndConditions();
  }, []);

  if (loading) {
    return <p>Loading...</p>;
  }

  if (error) {
    return <p style={{ color: "red" }}>Error: {error}</p>;
  }

  return (
    <div>
      <div className="profile-container">
        <h1 className="setting-header text-heading-h3 mb-3 mb-md-4">
          Terms and Conditions
        </h1>
        <div className="terms-content">
          {termsData.map((section, index) => (
            <div key={index} className="terms-text">
              <h3 className="text-body-b1 mb-0">{section.title}</h3>
              <p className="text-body-b3 mb-0">{section.content}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
